module.exports = __webpack_public_path__ + "static/media/K.8e3fc0ea.svg";